import React from 'react';
import { useState, useEffect } from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import '../App.css';
import 'typeface-roboto';
import { createTheme, ThemeProvider } from '@mui/material';
import Projects from './Projects';
const useStyles = {

  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },

};

function DevScreen() {
  const [value, setValue] = React.useState('one');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const classes = useStyles;
  const [isOpen, setIsOpen] = useState(true)

  return (
    <div style={{ marginTop: 80 }}>
      <Projects />
    </div>
  )
}

export default DevScreen;